export default "__VITE_ASSET__CaL0j6hz__"